
        import Agent from 'https://cdn.jsdelivr.net/npm/@release0/js@1.1.8/dist/web.js'

        Agent.initBubble({
          agent: "ag_d4fb60kc2mkuygjofv5vzdh4",
          theme: {
            button: { backgroundColor: "#152627" },
            chatWindow: { backgroundColor: "#eaeef7" },
          },
        });
